import React from "react";
import {
  Box,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  IconButton,
  Paper,
} from "@mui/material";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import LogicNodeEditor from "./LogicNodeEditor";

const LogicGroupEditor = ({ node, onChange, onDelete, questions, isRoot }) => {
  const children = node.children || [];
  const op = node.op || "AND";

  const updateChildAtIndex = (index, updatedChild) => {
    const newChildren = [...children];
    newChildren[index] = updatedChild;
    onChange({ ...node, children: newChildren });
  };

  const removeChildAtIndex = (index) => {
    const newChildren = children.filter((_, i) => i !== index);
    onChange({ ...node, children: newChildren });
  };

  const handleAddSlot = () => {
    onChange({
      ...node,
      children: [
        ...children,
        { type: "SLOT", slotId: "", questionId: null },
      ],
    });
  };

  const handleAddGroup = () => {
    onChange({
      ...node,
      children: [
        ...children,
        { type: "GROUP", op: "AND", children: [] },
      ],
    });
  };

  const handleOpChange = (e) => {
    onChange({ ...node, op: e.target.value });
  };

  /**  
   * GROUP = horizontal
   * CHILDREN = vertical
   */
  return (
    <Paper
      elevation={0}
      sx={{
        border: "1px solid #ddd",
        p: 2,
        borderRadius: 1,
        minWidth: 250,
        background: "#fafafa",
      }}
    >
      {/* Header */}
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <Typography variant="subtitle2" fontWeight={600}>
          {isRoot ? "Root group" : "Group"}
        </Typography>

        {!isRoot && (
          <IconButton size="small" onClick={onDelete}>
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        )}
      </Stack>

      {/* Children inside group = VERTICAL */}
      <Stack spacing={1}>
        {children.map((child, index) => (
          <Box key={index}>
            {/* Child card */}
            <Paper
              elevation={0}
              sx={{
                border: "1px solid #ccc",
                background: "#fff",
                borderRadius: 1,
                p: 1.5,
                mb: 1,
              }}
            >
              <LogicNodeEditor
                node={child}
                onChange={(updated) => updateChildAtIndex(index, updated)}
                onDelete={() => removeChildAtIndex(index)}
                questions={questions}
              />
            </Paper>

            {/* Operator BETWEEN children */}
            {index < children.length - 1 && (
              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                <Typography variant="caption">AND/OR:</Typography>
                <FormControl size="small" sx={{ width: 90 }}>
                  <InputLabel>Op</InputLabel>
                  <Select
                    label="Op"
                    value={op}
                    onChange={handleOpChange}
                  >
                    <MenuItem value="AND">AND</MenuItem>
                    <MenuItem value="OR">OR</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
            )}
          </Box>
        ))}
      </Stack>

      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        <Button size="small" variant="outlined" onClick={handleAddSlot}>
          Add placeholder
        </Button>
        <Button size="small" variant="outlined" onClick={handleAddGroup}>
          Add group
        </Button>
      </Stack>
    </Paper>
  );
};

export default LogicGroupEditor;
